export const data = {
	heading: 'Усиление и рост команды ',
	content: [
		'В 2018 году мы стали усиливать команду. Нам требовались специалисты из различных сфер: маркетинг и пиар, продуктовый менеджмент, разработка, юридическое сопровождение, финансовая аналитика. Именно  тогда мы заложили основу для организационной структуры внутри компании.',
		'Нам было важно находить одних из лучших специалистов в своих сферах, которые могли бы не только создавать удобные и эффективные продукты для клиентов, но и помогать команде постоянно расти, делиться своим опытом.',
	],
}
